module.exports = __webpack_public_path__ + "img/trash-files.3a605ac2.svg";